import React from "react";
import styled from "styled-components";
import PropTypes from "prop-types";

import { H1 } from "shared";
import { colors } from "shared/colors";
import {
    Wrapper,
    Header,
    ContainedGrid,
    HeaderContent,
    DummyElement,
    CloseIcon,
    Links,
    Link,
    LinkHeading,
    MobileSpacing
} from "./styles";

import { productMenu, nounProjectMenu } from "data/links";

let OverflowMenuMobile = ({ closeMenu, className }) => {
    const getLinks = ({ linkData }) =>
        linkData.map(link => (
            <Link
                key={link.name}
                onClick={closeMenu}
                href={link.href}
                target={link.external ? "_blank" : "_self"}
            >
                {link.name}
            </Link>
        ));

    const productMenuLinks = getLinks({ linkData: productMenu });
    const nounProjectMenuLinks = getLinks({ linkData: nounProjectMenu });

    return (
        <Wrapper className={className}>
            <Header>
                <ContainedGrid>
                    <HeaderContent
                        justifyContent="space-between"
                        alignItems="center"
                    >
                        <DummyElement />
                        <H1 size={16} bold>
                            Menu
                        </H1>
                        <CloseIcon
                            onClick={closeMenu}
                            fillColor={colors.brownishGreyTwo}
                        />
                    </HeaderContent>
                </ContainedGrid>
            </Header>
            <LinkHeading>Products</LinkHeading>
            <Links>{productMenuLinks}</Links>
            <LinkHeading>Noun Project</LinkHeading>
            <Links>{nounProjectMenuLinks}</Links>
            <MobileSpacing />
        </Wrapper>
    );
};

OverflowMenuMobile = styled(OverflowMenuMobile)``;

OverflowMenuMobile.propTypes = {
    closeMenu: PropTypes.func
};

export { OverflowMenuMobile };
